import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { ReasoningEffort } from "@/types/chat.type";

interface ChatModelStore {
  /** Last-picked model id (`"auto"` or a concrete provider id). */
  modelId: string | null;
  reasoningEffort: ReasoningEffort;
  setModelId: (modelId: string | null) => void;
  setReasoningEffort: (effort: ReasoningEffort) => void;
  setSelection: (modelId: string, effort: ReasoningEffort) => void;
}

const CHAT_MODEL_STORAGE_KEY = "chat-model-store";

/**
 * Persists the agent chat model + reasoning pick across reloads and agent
 * panels (universe, strategy, calendar). Composers still resolve the id against
 * the live models list when it loads.
 */
export const useChatModelStore = create<ChatModelStore>()(
  persist(
    (set) => ({
      modelId: null,
      reasoningEffort: "low",
      setModelId: (modelId) => set({ modelId }),
      setReasoningEffort: (reasoningEffort) => set({ reasoningEffort }),
      setSelection: (modelId, reasoningEffort) => set({ modelId, reasoningEffort }),
    }),
    {
      name: CHAT_MODEL_STORAGE_KEY,
      partialize: (state) => ({
        modelId: state.modelId,
        reasoningEffort: state.reasoningEffort,
      }),
    },
  ),
);
